import React, { useEffect, useState } from "react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import { getLoanList } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLoader } from "../../context/LoaderContext";
import CurrencyGTCell from "Common/Components/CurrencyGTCell";

const LoanList = () => {
  const [loans, setLoans] = useState([]);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const fetchData = async () => {
      showLoader();
      try {
        const params = {
          page: 0,
          size: 1000,
          sort: "loanId,desc"
        };

        const response = await getLoanList(params);
        const loansData = response.data?._embedded?.loans || [];
        setLoans(loansData);
      } catch (error) {
        toast.error("Error fetching expenses:" + error);
      } finally {
        hideLoader();
      }
    };
    fetchData();
  }, []);

  const columns = [
    {
      header: "Numero de Prestamo",
      accessorKey: "loanNumber",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Cliente",
      accessorKey: "loanApplication.customer.fullName",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Tipo de Prestamo",
      accessorKey: "loanApplication.typeLoan.name",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Saldo",
      accessorKey: "principalAmount",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ getValue }: any) => <CurrencyGTCell value={getValue()} />,
    },
    {
      header: "Tasa de Interes",
      accessorKey: "interestRate",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Fecha de Desembolso",
      accessorKey: "loanReleasedDate",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Fecha de Vencimiento",
      accessorKey: "loanDueDate",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Acciones",
      cell: ({ row }: any) => (
        <div className="flex gap-3">
          <Link
            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
            to={`/loan-info/${row.original.loanId}`}
          >
            <Eye className="inline-block size-3" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="col-span-12 card 2xl:col-span-12">
      <div className="card-body">
        <TableContainer
          isPagination={true}
          isSelect={true}
          isGlobalFilter={true}
          columns={columns}
          data={loans}
          customPageSize={5}
          divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
          tableclassName="hover group dataTable w-full text-sm align-middle whitespace-nowrap no-footer"
          theadclassName="border-b border-slate-200 dark:border-zink-500"
          trclassName="group-[.stripe]:even:bg-slate-50 group-[.stripe]:dark:even:bg-zink-600 transition-all duration-150 ease-linear group-[.hover]:hover:bg-slate-50 dark:group-[.hover]:hover:bg-zink-600 [&.selected]:bg-custom-500 dark:[&.selected]:bg-custom-500 [&.selected]:text-custom-50 dark:[&.selected]:text-custom-50"
          thclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500"
          tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
          PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
        />
      </div>
    </div>
  );
};

export default LoanList;
